import { useLayerStore } from "../state/useLayerStore";
import { LAYER_REGISTRY } from "../map/registry";
import { PRICE_YEARS } from "../map/layers/prices";

/**
 * Scrubbing this only swaps a paint expression on already-loaded tiles, so it
 * stays smooth — there is nothing to fetch between years.
 *
 * It appears only while a layer that carries a year series is switched on
 * (`usesYear` in the registry). With prices and individual sales both off, the
 * map is showing hazards, climate or transit — none of which move with the
 * sale year — and a slider that changes nothing visible is worse than no
 * slider.
 */
export function YearSlider() {
  const year = useLayerStore((s) => s.year);
  const setYear = useLayerStore((s) => s.setYear);
  const relevant = useLayerStore((s) =>
    LAYER_REGISTRY.some(
      (def) =>
        def.usesYear && !s.unavailable.includes(def.id) && s.isVisible(def.id),
    ),
  );

  if (!relevant) return null;

  const min = PRICE_YEARS[0];
  const max = PRICE_YEARS[PRICE_YEARS.length - 1];

  return (
    <div className="absolute bottom-8 left-1/2 z-10 w-[min(28rem,calc(100%-2rem))] -translate-x-1/2 rounded-xl border border-line bg-surface/95 px-4 py-3 shadow-lg backdrop-blur">
      <div className="flex items-baseline justify-between">
        <label htmlFor="year" className="text-[11px] font-medium uppercase tracking-wider text-ink-soft">
          Sale year
        </label>
        <span className="text-lg font-semibold tabular-nums">{year}</span>
      </div>
      <input
        id="year"
        type="range"
        min={min}
        max={max}
        step={1}
        value={year}
        onChange={(e) => setYear(Number(e.target.value))}
        className="mt-1.5 w-full accent-accent"
      />
      <div className="flex justify-between text-[10px] tabular-nums text-ink-soft">
        {PRICE_YEARS.map((y) => (
          <span key={y}>{y}</span>
        ))}
      </div>
    </div>
  );
}
